import { render } from "./enseigne.vue?vue&type=template&id=17916c4b&scoped=true"
import script from "./enseigne.vue?vue&type=script&lang=js"
export * from "./enseigne.vue?vue&type=script&lang=js"

import "./enseigne.vue?vue&type=style&index=0&id=17916c4b&lang=css&scoped=true"

import exportComponent from "/Users/jean-yvesfournet/Documents/projects/javascript/vue/shop-flash/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17916c4b"]])

export default __exports__